import { ActionIcon } from "PFComponents/action_icon";
import { useDeleteReports } from "PFCore/hooks/queries/analytics/use_reports";
import colors from "PFTheme/tokens/colors";
import React, { JSX, useState } from "react";

import { ConfirmDeleteModal } from "./confirm_delete_modal";

type DeleteActionProps = {
  reportId: number;
  reportName: string;
};

export const DeleteButton = ({ reportId, reportName }: DeleteActionProps): JSX.Element => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { mutate } = useDeleteReports(reportId);

  return (
    <>
      <ActionIcon onClick={() => setIsModalVisible(true)} name="remove" fill={colors.paletteBlue0} />
      {isModalVisible && (
        <ConfirmDeleteModal
          reportName={reportName}
          onClose={() => setIsModalVisible(false)}
          onDelete={() => mutate(reportId)}
        />
      )}
    </>
  );
};
